import { PermissionsEnum } from "@/auth/interfaces";
import { TransferenciaInventarioFilter } from "@/erp/inventario/transferencia-inventario";
import { TransferenciaInventarioFiltro } from "@/erp/inventario/transferencia-inventario/shared/transferencia-inventario/TransferenciaInventarioFiltro";
import {
  EstadoTransitoInventarioENUM,
  gridSizeMdLg2,
  hasPermission,
  ROUTER_PATHS,
  sanitizeTodos,
  urlBackend,
  useLoaders,
  useTableFilter,
  useTableServerSideFiltering,
  useUploadFile,
} from "@/shared";
import { useFetchGetTransitoInventario } from "@/shared/actions/erp/transito_inventaro.actions";
import { GeneralTable } from "@/shared/components/ui";
import { useTableSolicitudTransferenciaInventario } from "@/shared/hooks/useTableSolicitudTransferenciaInventario";
import { ITransitoInventario } from "@/shared/interfaces/erp/administration/transito_inventario.interface";
import { useUiStore } from "@/store/ui";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { Button, Grid, IconButton } from "@mui/material";
import dayjs from "dayjs";
import { useForm } from "react-hook-form";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

interface TableRecepcionTransferenciaInventarioProps {
  estado_transito?: string;
  enable_action?: boolean;
}

const TableTransitoTransferenciaInventario = ({
  estado_transito = EstadoTransitoInventarioENUM.EN_TRANSITO,
}: TableRecepcionTransferenciaInventarioProps) => {
  const navigate = useNavigate();

  ///* form
  const form = useForm<TransferenciaInventarioFilter>({
    defaultValues: {
      producto_codigo: null,
      producto_serie: null,
      fecha_creacion_after: dayjs().subtract(30, "day").format("YYYY-MM-DD"),
      fecha_creacion_before: dayjs().format("YYYY-MM-DD"),
    },
  });

  const { columnaRecepcionTrasladoInventario } =
    useTableSolicitudTransferenciaInventario();

  const setGeneralLoading = useUiStore((s) => s.setGeneralLoading);
  const isGlobalLoading = useUiStore((s) => s.isGlobalLoading);

  const { globalFilter, pagination, setPagination } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { descargarPdfDesdeurl, downloadExcelFileWithAxios } = useUploadFile();

  const { pageIndex, pageSize } = pagination;

  const {
    isLoading,
    data: transferenciaProducto,
    isRefetching,
  } = useFetchGetTransitoInventario({
    page: pageIndex + 1,
    page_size: pageSize,
    estado_transito: estado_transito,
    numero_referencia: globalFilter,
    producto_codigo: sanitizeTodos(form.getValues().producto_codigo),
    producto_serie: sanitizeTodos(form.getValues().producto_serie),
    fecha_creacion_after: form.getValues().fecha_creacion_after,
    fecha_creacion_before: form.getValues().fecha_creacion_before,
    ...filterObject,
    filterByState: false,
  });

  const onEdit = (data: ITransitoInventario) => {
    navigate(
      `${ROUTER_PATHS.inventario.recepcionEditTransferenciaInventarioNav}/${data.id_transito_inventario}`,
    );
  };

  const handleDescargarPdf = async (value: ITransitoInventario) => {
    try {
      setGeneralLoading(true);
      const fileName = `${value.ubicacion_origen_data?.nombre}_${value.ubicacion_destino_data?.nombre}_${dayjs().format("YYYY-MM-DD")}`;

      if (value.traslado_inicial_data == null) {
        toast.info("No existe documento. [404]");
        return;
      }

      descargarPdfDesdeurl(value.traslado_inicial_data.url_pdf, fileName);
    } catch (error) {
    } finally {
      setGeneralLoading(false);
    }
  };

  const setIsGlobalLoading = useUiStore((s) => s.setIsGlobalLoading);

  useLoaders(isGlobalLoading);

  return (
    <Grid container justifyContent={"flex-end"} spacing={3}>
      <TransferenciaInventarioFiltro form={form} />

      {hasPermission(PermissionsEnum.transito_inventario_excel) && (
        <Grid item {...gridSizeMdLg2}>
          <Button
            fullWidth
            startIcon={<PiMicrosoftExcelLogoFill />}
            variant="contained"
            color="success"
            size="small"
            onClick={async () => {
              setIsGlobalLoading(true);

              try {
                await downloadExcelFileWithAxios(
                  `${urlBackend}api/v1/transitoinventario/export-excel/?estado_transito=${estado_transito}`,
                  `transferencia_inventario_${dayjs().unix()}.xlsx`,
                );
              } catch (error) {
                toast.error("Error al descargar el archivo");
                console.error(error);
              } finally {
                setIsGlobalLoading(false);
              }

              //downloadKardexExcel()
            }}
          >
            EXCEL
          </Button>
        </Grid>
      )}

      <Grid item xs={12}>
        <GeneralTable<ITransitoInventario>
          columns={columnaRecepcionTrasladoInventario}
          data={transferenciaProducto?.data.data || []}
          //
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={transferenciaProducto?.data.count}
          // // actions
          //actionsColumnSize={50}
          // crud
          onEdit={onEdit}
          canDelete={false}
          positionActionsColumn="first"
          enableEditing={true}
          ///* filters - server side
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          enableSorting={false}
          canEdit={false}
          enableColumnActions={true}
          // crud
          showCustomActionBtnSpace={true}
          customActionBtnSpace={(value) => {
            return (
              <Grid container>
                <Grid item>
                  <IconButton
                    onClick={() => {
                      handleDescargarPdf(value);
                    }}
                  >
                    <CloudDownloadIcon color="info" />
                  </IconButton>
                </Grid>
              </Grid>
            );
          }}
        />
      </Grid>
    </Grid>
  );
};

export default TableTransitoTransferenciaInventario;
